/* eslint-disable max-lines */
/* eslint-disable max-lines */

const colors = {
	black: '#000000',
	white: '#ffffff',

	blue: '#087DAE',
	blue_light: '#14B2F4',
	blue_lighter: '#62CCF8',
	blue_lightest: '#B1E5FB',
	blue_ultraLight: '#EEF8FF',
	blue_dark: '#065E83',
	blue_darker: '#043E57',
	blue_darkest: '#021F2C',
	blue_midDark: '#5864fb',

	yellow: '#FFCA28',
	yellow_light: '#FFD75E',
	yellow_lighter: '#FFE494',
	yellow_lightest: '#FFF2C9',
	yellow_dark: '#DDA700',
	yellow_darker: '#936F00',
	yellow_darkest: '#4A3800',

	green: '#86C65A',
	green_light: '#A4D483',
	green_lighter: '#C3E3AC',
	green_lightest: '#E1F1D6',
	green_dark: '#6DB63A',
	green_darker: '#52862E',
	green_darkest: '#31501C',
	green_ultraDark: '#2DA438',

	red: '#E62C14',

	teal: '#009EA1',
	teal_light: '#04BFBF',
	teal_lighter: '#68DCDC',
	teal_lightest: '#B4E8E8',
	teal_dark: '#008A8D',
	teal_darker: '#006365',
	teal_darkest: '#003B3C',

	orange: '#F9570A',
	orange_light: '#FB8066',
	orange_lighter: '#FCAB99',
	orange_lightest: '#FED5CC',
	orange_ultraLight: '#FFF8F8',
	orange_dark: '#E24827',
	orange_darker: '#B82405',
	orange_darkest: '#6E1603',
	orange_ultraDark: '#d24c0c',
	orange_carrot: '#f57f17',

	purple: '#5867E8',
	purple_light: '#828DEE',
	purple_lighter: '#ACB3F3',
	purple_lightest: '#D5D9F9',
	purple_dark: '#1D30D3',
	purple_darker: '#13208D',
	purple_darkest: '#0A1046',

	gray_10: '#171820',
	gray_20: '#404040',
	gray_30: '#676671',
	gray_40: '#92919B',
	gray_50: '#BBBAC0',
	gray_60: '#D9D8DC',
	gray_70: '#E5E4E8',
	gray_80: '#F2F1F3',
	gray_90: '#F9F9F9',
	gray_OLD: '#E8E8E8',
	gray_100: '#4c4c4c',
	gray_110: '#848484',
	gray_120: '#E6EAEE',
	gray_130: '#EBEBEC',
	gray_140: '#898787',
	gray_150: '#F2F2F4',
	gray_160: '#F8F7F7',
	gray_170: '#F5F5F5',
};

export const MaxWidthBreakpoint = {
	Mobile: 500,
	Tablet: 768,
	BigTablet: 1137,
	MidSizeTablet: 1024,
	MobileBelow: 350,
};

export const MinWidthBreakpoint = {
	Tablet: 501,
	Desktop: 801,
};

export const theme = {
	breakpoints: {
		/**
		 * DEPRECATED: It's recommended that you not use the `mobile` breakpoint
		 * when writing CSS. The recommended approach is to write mobile CSS first,
		 * and then use the `tabletUp`, `desktopUp`, `lgDesktopUp`, and
		 * `xlDesktopUp` breakpoints to override that CSS for larger screen sizes.
		 *
		 * 500 px and below.
		 */
		mobileBelow: `@media screen and (max-width: ${MaxWidthBreakpoint.MobileBelow}px)`,
		/** 350 px and up. */
		mobile: `@media screen and (max-width: ${MaxWidthBreakpoint.Mobile}px)`,
		/** 501 px and up. */
		tabletUp: `@media screen and (min-width: ${MinWidthBreakpoint.Tablet}px)`,
		/** 768 px and down */
		tabletDown: `@media screen and (max-width: ${MaxWidthBreakpoint.Tablet}px)`,
		/** 1137 px and down */
		bigTablet: `@media screen and (max-width: ${MaxWidthBreakpoint.BigTablet}px)`,
		/** 801 px and up. */
		desktopUp: `@media screen and (min-width: ${MinWidthBreakpoint.Desktop}px)`,

		midSizeTablet: `@media screen and (max-width: ${MaxWidthBreakpoint.MidSizeTablet}px)`,
	},
	borderRadius: {
		/** 2px, 0.125rem **/
		checkbox: '0.125rem',
		/** 4px, 0.25rem */
		md: '0.25rem',
		/** 4px, 0.25rem */
		btn: '0.25rem',
		card: '0.25rem',
		cdsCard: '10px',
		searchBox: '0.25rem',
	},
	searchBox: {
		minWidth: '18.125rem',
	},
	zIndex: {
		label: 1,
		dropdown: 2,
		backgroundLayout: 0,
		headerBackground: 2,
		background: -1,
		idCardbg: 9,
		idCardTransparent: 10,
		idCardText: 11,
	},
	boxShadow: {
		/* Standard Shadow - Light */
		modalOverlay: 'rgba(0, 0, 0, 0.5);',
		standard: '0px 2px 10px rgba(23, 24, 32, 0.1);',
		formBorder:
			'rgba(221, 225, 239, 0.2) 0 3px 5px -1px, rgba(221, 225, 239, 0.14) 0px 5px 8px 0px, rgba(221, 225, 239, 0.12) 0px 1px 14px 0px;',
		inputBorder: '0 1px 1px inset rgba(0, 0, 0, 0.08), 0 0 8px rgba(246, 196, 88, 0.50);',
	},
	spacing: {
		xxxs: '0px',
		/** 2px, 0.125rem */
		xxs: '2px',
		/** 4px, 0.25rem */
		xs: '4px',
		/** 8px, 0.5rem */
		sm: '8px',
		/** 16px, 1rem */
		md: '16px',
		/** 24px, 1.5rem */
		lg: '24px',
		/** 32px, 2rem */
		xl: '32px',
		/** 40px, 2.5rem */
		xxl: '40px',
		/** 48px, 3rem */
		xxxl: '48px',
		/** 56px, 3.5rem */
		xxxxl: '56px',
		/** 64px, 3.5rem */
		xxxxxl: '64px',
		/** 100px, 6.25rem */
		xxxxxxxl: '100px',
	},
	baseFont: '"Poppins", sans-serif',
	fontSize: {
		_56: '56px',
		_36: '36px',
		_32: '32px',
		_24: '24px',
		_21: '21px',
		_18: '18px',
		_16: '16px',
		_14: '14px',
		_12: '12px',
		_11: '11px',
		_10: '10px',
		_8: '8px',
	},
	weight: {
		light: 300,
		regular: 400,
		medium: 500,
		semi: 600,
		bold: 700,
	},
	color: {
		/* ---- BODY ---- */
		body: colors.white,
		bodyText: colors.gray_100,
		bodyTextSecondary: colors.gray_110,

		/* ---- HEADER ---- */
		headerText: colors.white,
		headerTextSecondary: colors.gray_30,
		headerBG: colors.blue_midDark,

		/* ---- LINKS ---- */
		link: colors.blue_midDark,
		linkVisited: colors.purple_dark,
		linkHover: colors.blue_midDark,
		linkActive: colors.blue_midDark,
		linkSelected: colors.blue_midDark,
		linkDisabled: colors.gray_30,

		/* ----- Icons ------ */
		iconColor: colors.gray_140,

		/* ---- MENU ---- */

		/* ---- AVATARS ---- */

		/* ---- USER NAV ---- */

		/* ---- BUTTONS ---- */
		primaryButtonBg: colors.blue_midDark,
		primaryButtonHover: colors.blue_midDark,
		primaryButtonFocusBorder: colors.blue_midDark,
		primaryButtonFocusText: colors.white,
		secondaryButtonBg: colors.white,
		secondaryButtonColor: colors.blue_midDark,
		secondaryButtonBorder: colors.blue_midDark,
		secondaryButtonFocusBorder: colors.gray_30,
		secondaryButtonFocusText: colors.gray_30,
		buttonDisabled: colors.gray_OLD,
		dropdownButtonBg: colors.gray_150,

		/* ---- ALERTS ---- */
		alertError: colors.white,
		alertErrorBorder: colors.red,
		alertErrorText: colors.red,
		alertInfoText: colors.blue_midDark,
		alertWarning: colors.yellow,
		alertWarningText: colors.yellow,
		alertWarningTextDark: colors.yellow_darker,
		alertSuccess: colors.white,
		alertSuccessText: colors.green_ultraDark,
		alertSuccessBorder: colors.green_ultraDark,

		/* ---- FORMS ---- */
		formError: colors.red,
		inputBorder: colors.gray_120,
		formText: colors.gray_100,
		label: colors.blue_midDark,
		inputHover: colors.gray_120,
		inputFocus: colors.blue_midDark,
		formTextDisabled: colors.gray_100,
		formDisabledBg: colors.gray_80,
		dropdownItemBorder: colors.black,
		checkboxBorder: colors.gray_50,
		dropdownHover: colors.blue_lightest,
		dropdownBg: colors.white,
		formBg: colors.gray_170,

		/* ---- DATA GRID ---- */
		gridHeader: colors.gray_150,
		gridPrimaryRow: colors.white,
		gridSecondaryRow: colors.gray_160,
		gridText: colors.gray_100,
		gridBorder: colors.gray_130,

		/* ---- LOADING ---- */
		loadingSpinner: colors.white,
		loadingDot: colors.black,

		/* ---- TEXT ---- */
		textDisabled: colors.gray_40,
		textInfo: colors.blue_midDark,
		textSuccess: colors.green_ultraDark,
		textAlert: colors.red,
		textSubtitle: colors.gray_10,

		/* ---- FOOTER ---- */
		footerBg: colors.gray_130,
		footerCopyright: colors.gray_140,

		/* ----- MODEL ------*/
		modelBackgroundColor: colors.blue_midDark,
		modelTextColor: colors.white,

		/* --- SEPARATORS ---- */
		infoSeparator: colors.gray_60,

		/* ------ WIDGETS ------- */

		/* ------ ICONS ------- */

		/* ------ Checkbox ------- */
		checkboxBg: colors.orange,
		checkboxHover: colors.gray_40,

		/* ------ STUDENT ID ------- */
		idText: colors.black,
		idHeader: colors.orange_carrot,

		/* ------ OTHERS ------- */
		cardColorFont: colors.gray_140,
		cardBgColor: colors.gray_70,
	},
};
